import { configureStore } from '@reduxjs/toolkit';
import agentSlice from './agentSlice';
import interactionsSlice from './interactionsSlice';
import parametersSlice from './parametersSlice';


const store = configureStore({
    reducer: {
        agent: agentSlice,
        interaction: interactionsSlice,
        parameters: parametersSlice
    }
});
export default store;